const BUY_IN_KEY_PREFIX = 'tp:buy-in:';

export function saveBuyInAmount(tableProfileId: number, amount: number): void {
  sessionStorage.setItem(`${BUY_IN_KEY_PREFIX}${tableProfileId}`, String(Math.floor(amount)));
}

export function readBuyInAmount(tableProfileId: number): number | undefined {
  const raw = sessionStorage.getItem(`${BUY_IN_KEY_PREFIX}${tableProfileId}`);
  if (!raw) return undefined;
  const value = Math.floor(Number(raw));
  return Number.isFinite(value) && value > 0 ? value : undefined;
}

export function clearBuyInAmount(tableProfileId: number): void {
  sessionStorage.removeItem(`${BUY_IN_KEY_PREFIX}${tableProfileId}`);
}
